export const OPEN_DROPDOWN_MENU = 'OPEN_DROPDOWN';
export const SET_CURRENT_ROW = 'SET_CURRENT_ROW';
export const CLOSE_DROPDOWN_MENU = 'CLOSE_DROPDOWN';
export const SET_PAGE = 'SET_PAGE';
